import { Partner } from 'app/api/@generated/backend';

import { createAppAsyncThunk } from 'app/redux/utils/thunk-utils';
import { PartnersService } from 'app/services/partners-service';
import { RequestType } from 'app/pages/order/redux/model/order-request';

export const fetchPartnersActionCreator = createAppAsyncThunk<Partner[]>(
    'order/getPartners',
    async () => {
        try {
            return await PartnersService.getAvailablePartners();
        } catch (reason) {
            return Promise.reject();
        }
    },
    {
        getPendingMeta: () => ({ requestType: RequestType.GET_PARTNERS }),
    },
);
